module.exports = __webpack_public_path__ + "img/4.8c006512.jpg";